jQuery(function () {
  // 共通要素 ---------------------------------------//
  const globalContainer = $(".globalContainer"); // body直下　全ての要素を囲っています
  const header = $(".header"); // ヘッダー
  const drawer = $(".drawer"); // ドロワー
  const drawerBtn = $(".drawerBtn"); // ヘッダーのドロワー開閉ボタン

  // アニメーションの設定 ---------------------------------------//
  function animationDelayAdd(animationContent, column) {
    let animationContentNum = 0;
    let counter = 0;
    let columnCheck = column;

    if ($(window).width() >= 768) {
      animationContent.each(function () {
        $(this).css("transition-delay", `${animationContentNum}s`);
        animationContentNum += 0.3;
        counter += 1;
        if (counter == columnCheck) {
          animationContentNum = 0;
          counter = 0;
        }
      });
    }
  }

  // トップページ -----------------------------//
  // トップページのローディングアニメーション
  if ($(".topPage").length) {
    $(".loader").addClass("is_loaded");
    $("body").addClass("loadingAnime");
    setTimeout(function () {
      $(".topKvLeadTxt").addClass("is_active");
    }, 900);
  }

  //てるクリニックの特徴
  $(".featureList__img").addClass("animation_fadeIn");
  animationDelayAdd($(".featureList--01 .featureList__img"));
  animationDelayAdd($(".featureList--02 .featureList__img"));

  // 理学療法室
  $(".topPosts .postCard__item").addClass("animation_fadeIn");
  animationDelayAdd($(".topPosts .postCard__item"));

  // baseball news
  $(".topBb .postCard__item").addClass("animation_fadeIn");
  animationDelayAdd($(".topBb .postCard__item"));

  // 下層 -----------------------------//
  // 病院紹介ページ
  $(window).on("load resize", function () {
    if ($(".aboutPage").length && $(window).width() >= 600) {
      $(".aboutKv").addClass("animation_fadeIn");
      $(".OverlapMedia__img").addClass("animation_fadeIn");
      $(".media__img").addClass("animation_fadeIn");
    }
  });

  // 理学療法室
  $(".physicalPostsLead .OverlapMedia__img").addClass("animation_fadeIn");

  // カード系
  $(".card__img").addClass("animation_fadeIn");
  animationDelayAdd($(".card__img"), 2);

  // 人気記事
  $(".physicalPopular .postCard__item").addClass("animation_fadeIn");
  animationDelayAdd($(".physicalPopular .postCard__item"));

  // 野球ページ -----------------------------//
  // 野球トップページのローディングアニメーション
  if ($(".bbPage").length) {
    var topBbAnimeContents =
      ".bbKvTtl__lg, .bbKvTtl__sm, .bbKvImg__player , .bbKv__resultBox";

    $(topBbAnimeContents).addClass("is_active");
  }

  // 野球トップ　news
  $(".bbColumn .postCard__item").addClass("animation_fadeIn");
  animationDelayAdd($(".bbColumn .postCard__item"));

  // スライダー MV ---------------------------------------//
  const swiper = new Swiper(".topKvSlider", {
    loop: true,
    effect: "fade",
    speed: 3000,
    allowTouchMove: false,
    autoplay: {
      delay: 4000,
    },
  });

  const memberSlider = new Swiper(".memberSlider", {
    loop: true,
    speed: 1500,
    slidesPerView: 1.75,
    centeredSlides: true,
    spaceBetween: 20,
    grabCursor: true,

    autoplay: {
      delay: 4000,
    },

    navigation: {
      nextEl: ".bbTopMember__slider .swiper-button-next",
      prevEl: ".bbTopMember__slider .swiper-button-prev",
    },

    breakpoints: {
      1280: {
        slidesPerView: 3.33,
        centeredSlides: true,
        spaceBetween: 30,
      },

      767: {
        slidesPerView: 3.33,
        centeredSlides: true,
        spaceBetween: 20,
      },

      599: {
        slidesPerView: 1.75,
        centeredSlides: true,
        spaceBetween: 60,
      },
    },
  });

  const wideImgSlider = new Swiper(".wideImgSlider", {
    loop: true,
    effect: "fade",
    speed: 3000,
    grabCursor: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },

    autoplay: {
      delay: 4000,
    },
  });

  // スクロール時の共通処理 ---------------------------------------//
  $(window).on("load scroll", function () {
    var windowHeight = $(window).height(); // 画面高さ
    var headerHeight = header.innerHeight(); // ヘッダーの高さ
    var scrollTop = $(window).scrollTop(); // スクロール量

    var headerHeight;
    if ($(window).width() >= 1000) {
      headerHeight = 204;
    } else {
      headerHeight = header.innerHeight();
    }

    // ヘッダー固定
    if ($(this).scrollTop() > 300) {
      header.addClass("is_fixed");
      globalContainer.css("padding-top", headerHeight + "px");

      setTimeout(function () {
        header.addClass("add_transition");
      }, 100);
    } else {
      header.removeClass("is_fixed");
      globalContainer.css("padding-top", 0);

      setTimeout(function () {
        header.removeClass("add_transition");
      }, 100);
    }

    // ヘッダー表示非表示
    if ($(".topPage").length || $(".bbTop").length) {
      if ($(this).scrollTop() > windowHeight) {
        header.addClass("is_transform");
      } else {
        header.removeClass("is_transform");
      }
    } else {
      if ($(this).scrollTop() > windowHeight / 2) {
        header.addClass("is_transform");
      } else {
        header.removeClass("is_transform");
      }
    }

    // コンテンツのアニメーション開始
    const animationList =
      ".animation_fadeIn, .animation_fadeUp, .animation_fadeRight, .bbPageToTop";

    $(animationList).each(function () {
      var target = $(this).offset().top - windowHeight * 0.85;
      if (scrollTop > target) {
        $(this).addClass("is_active");
      }
    });
  });

  // アンカーリンク ---------------------------------------//
  let headerHeight;
  if ($(window).width() >= 1000) {
    headerHeight = 127;
  } else {
    headerHeight = $(".header").innerHeight();
  }

  let urlHash = location.hash;
  if (urlHash) {
    setTimeout(function () {
      let position = $(urlHash).offset().top - headerHeight;
      $("html, body").animate(
        {
          scrollTop: position,
        },
        0
      );
      if ($(".aboutPage").length) {
        $(".OverlapMedia__img").addClass("is_active");
      }
    }, 300);
  }

  // ドロワーの開閉 ---------------------------------------//
  function notscroll(e) {
    e.preventDefault();
  }

  drawerBtn.click(function () {
    globalContainer.toggleClass("is_drawerOpen");

    if (globalContainer.hasClass("is_drawerOpen")) {
      document.addEventListener("touchmove", notscroll, {
        passive: false,
      });
      document.addEventListener("mousewheel", notscroll, {
        passive: false,
      });
    } else {
      document.removeEventListener("touchmove", notscroll, {
        passive: false,
      });
      document.removeEventListener("mousewheel", notscroll, {
        passive: false,
      });
    }
  });

  // 求人ブロックの切り替え ---------------------------------------//
  if ($(".reserveSec").length) {
    var reserveNavItem = $(".reserveNav__item");
    var reserve = $(".reserve");
    var reserveId = 1;

    reserveNavItem.each(function () {
      $(this).click(function () {
        reserveNavItem.removeClass("is_current");
        $(this).addClass("is_current");
        reserveId = $(this).data("reserve");

        reserve.css("display", "none");
        reserve.each(function () {
          if ($(this).data("reserve") == reserveId) {
            $(this).fadeIn();
          }
        });
      });
    });
  }

  // モーダル処理 ---------------------------------------//
  var modal = $(".modal");
  var closeBtn = $(".closeBtn");
  var modalBtn = $(".modalBtn");
  var modalBlock = $(".modalBlock");

  function modalClose() {
    modal.fadeOut();
    modalBlock.fadeOut();
  }

  modal.click(function () {
    modalClose();
  });

  closeBtn.click(function () {
    modalClose();
  });

  modalBtn.each(function () {
    $(this).click(function () {
      $(this).next(modalBlock).fadeIn();
      modal.fadeIn();
    });
  });

  // 試合結果カードの高さ調整 ---------------------------------------//
  if ($(".resultCard")) {
    var h = 0;
    var resultCardTop = $(".resultCard__top");

    $(window).on("load resize", function () {
      h = 0;
      resultCardTop.css("height", "auto");

      if ($(window).width() >= 600) {
        resultCardTop.each(function () {
          if ($(this).innerHeight() > h) {
            h = $(this).innerHeight();
          }
        });

        resultCardTop.css("height", h + "px");
      }
    });
  }

  // 表示調整 -----------------------------//
  // 試合結果の年別アーカイブに「年」を表示
  if ($(".sideCat--game").length) {
    var sideCatLink = $(".sideCat--game .sideCat__link");
    sideCatLink.each(function () {
      var beforeTxt = $(this).text().slice(0, 4);
      var label = "年";
      var afterTxt = $(this).text().slice(4);
      var txt = beforeTxt + label + afterTxt;
      $(this).text(txt);
    });
  }

  // アーカイブページで該当するカテゴリーに色をつける
  if ($(".sidebar").length) {
    var sideCatLink = $(".sideCat__link");
    var sideCatHref;
    var path = location.pathname;

    if ($(".articleBlock").length) {
      return;
    }

    if (
      path.indexOf("news_cat") >= 0 ||
      path.indexOf("physical_therapy_cat") >= 0
    ) {
      sideCatLink.removeClass("is_current");

      if (path.indexOf("news_cat") >= 0) {
        path = path.substr(path.indexOf("news_cat") + 9);
      } else if (path.indexOf("physical_therapy_cat") >= 0) {
        path = path.substr(path.indexOf("physical_therapy_cat") + 21);
      }

      var pathArray = path.split("/");

      sideCatLink.each(function () {
        sideCatHref = $(this).attr("href");
        if (sideCatHref.indexOf(pathArray[0]) >= 0) {
          $(this).addClass("is_current");
        }
      });
    } else if (path.indexOf("date") >= 0) {
      sideCatLink.removeClass("is_current");

      path = path.substr(path.indexOf("date") + 5);

      var pathArray = path.split("/");

      sideCatLink.each(function () {
        sideCatHref = $(this).attr("href");
        if (
          sideCatHref.indexOf(pathArray[0]) >= 0 &&
          sideCatHref.indexOf(pathArray[1]) >= 0
        ) {
          $(this).addClass("is_current");
        }
      });
    } else {
      if (!$(".sideCat").hasClass("sideCat--game")) {
        sideCatLink.eq(0).addClass("is_current");
      }
    }
  }

  // コラムの表示ボタン ---------------------------------------//
  if ($(".bbPosts").length) {
    var num = 3;

    $("#bbPostsBtn").on("click", function () {
      const hiddenTags = $(".bbPosts .postCard__item.is_hide");
      var hiddenTagsNum = hiddenTags.length;

      if (num > hiddenTagsNum) {
        num = hiddenTagsNum;
      }

      hiddenTags.slice(0, num).slideToggle();
      hiddenTags.slice(0, num).removeClass("is_hide");

      if (num == hiddenTagsNum) {
        $("#bbPostsBtn").fadeOut();
      }
    });

    $("#bbPostsBtn").trigger("click");
  }

  // SPホバーアクション削除 ---------------------------------------//
  var touch =
    "ontouchstart" in document.documentElement ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0;

  if (touch) {
    try {
      for (var si in document.styleSheets) {
        var styleSheet = document.styleSheets[si];
        if (!styleSheet.rules) continue;

        for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
          if (!styleSheet.rules[ri].selectorText) continue;

          if (styleSheet.rules[ri].selectorText.match(":hover")) {
            styleSheet.deleteRule(ri);
          }
        }
      }
    } catch (ex) {}
  }
});
